module.exports = __webpack_public_path__ + "img/main-slide-1.a6ce6018.png";